import HeaderIconButton from "./HeaderIconButton";
import { Icon } from "../ui/Icon";
import { getIframeDimensions } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/utils/getIframeDimensions";
import clsx from "clsx";
import useRecipient from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/(tabs)/messages/[id]/lib/client/hooks/useRecipient";
import { socket } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/socket";
import { useLauncherStore } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/contexts/LauncherStoreContext";
import { useShallow } from "zustand/react/shallow";
import { useLauncherContext } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/contexts/LauncherContext";
import { useWasClosed } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/DeviceContext";

export default function CloseButton({
  messengerId,
  nudgeRight,
  conversationId,
}: {
  messengerId?: string;
  nudgeRight?: boolean;
  conversationId?: string;
}) {
  const { showLauncherButton, setIsOpen, config } = useLauncherStore(
    useShallow((state) => ({
      showLauncherButton: state.showLauncherButton,
      setIsOpen: state.setIsOpen,
      config: state.config,
    })),
  );
  const { connection } = useLauncherContext();
  const { setWasClosed } = useWasClosed();

  const recipient = useRecipient();

  const offsetBottom = config?.settings?.displaySettings.placement?.offsetBottom ?? 0;
  const offsetSide = config?.settings?.displaySettings.placement?.offsetSide ?? 0;

  return (
    <HeaderIconButton
      onClick={async () => {
        if (!messengerId) return;

        // We also trigger this in the useSocketEvents useEffect on isOpen change
        // But parent.close() is called below, so the app could be unmounted before the useEffect runs
        if (conversationId && recipient?.device) {
          socket.emit("userPresence", conversationId, {
            created_at: new Date().toUTCString(),
            type: "exited",
            device: recipient.device,
            recipient: recipient,
            reason: "Clicked conversation close button",
          });
        }

        if (!connection?.current) return;
        const parentApi = await connection.current.promise;
        const parentViewDimensions = await parentApi.getViewDimensions(messengerId);
        const data = getIframeDimensions({
          isOpen: false,
          showLauncherButton,
          offsetBottom,
          offsetSide,
          parentViewDimensions,
        });

        parentApi.close(messengerId, data);
        setIsOpen(false);
        // Prevent the widget auto re-opening on refresh
        setWasClosed(true);
      }}
      className={clsx("p-0", nudgeRight && "-mr-4")}
    >
      <Icon icon="dazzle-linear-xmark" size="text-2xl" className="font-medium" />
    </HeaderIconButton>
  );
}
